export default {
  AF: {
    code: 'AF',
    name: 'Afghanistan',
    alpha3: 'AFG',
    numeric: 4,
    unicodeFlag: '🇦🇫',
    currency: 'AFN',
  },
  AX: {
    code: 'AX',
    name: 'Åland Islands',
    alpha3: 'ALA',
    numeric: 248,
    unicodeFlag: '🇦🇽',
    currency: 'EUR',
  },
  AL: {
    code: 'AL',
    name: 'Albania',
    alpha3: 'ALB',
    numeric: 8,
    unicodeFlag: '🇦🇱',
    currency: 'ALL',
  },
  DZ: {
    code: 'DZ',
    name: 'Algeria',
    alpha3: 'DZA',
    numeric: 12,
    unicodeFlag: '🇩🇿',
    currency: 'DZD',
  },
  AS: {
    code: 'AS',
    name: 'American Samoa',
    alpha3: 'ASM',
    numeric: 16,
    unicodeFlag: '🇦🇸',
    currency: 'USD',
  },
  AD: {
    code: 'AD',
    name: 'Andorra',
    alpha3: 'AND',
    numeric: 20,
    unicodeFlag: '🇦🇩',
    currency: 'EUR',
  },
  AO: {
    code: 'AO',
    name: 'Angola',
    alpha3: 'AGO',
    numeric: 24,
    unicodeFlag: '🇦🇴',
    currency: 'AOA',
  },
  AI: {
    code: 'AI',
    name: 'Anguilla',
    alpha3: 'AIA',
    numeric: 660,
    unicodeFlag: '🇦🇮',
    currency: 'XCD',
  },
  AQ: {
    code: 'AQ',
    name: 'Antarctica',
    alpha3: 'ATA',
    numeric: 10,
    unicodeFlag: '🇦🇶',
    currency: null,
  },
  AG: {
    code: 'AG',
    name: 'Antigua and Barbuda',
    alpha3: 'ATG',
    numeric: 28,
    unicodeFlag: '🇦🇬',
    currency: 'XCD',
  },
  AR: {
    code: 'AR',
    name: 'Argentina',
    alpha3: 'ARG',
    numeric: 32,
    unicodeFlag: '🇦🇷',
    currency: 'ARS',
  },
  AM: {
    code: 'AM',
    name: 'Armenia',
    alpha3: 'ARM',
    numeric: 51,
    unicodeFlag: '🇦🇲',
    currency: 'AMD',
  },
  AW: {
    code: 'AW',
    name: 'Aruba',
    alpha3: 'ABW',
    numeric: 533,
    unicodeFlag: '🇦🇼',
    currency: 'AWG',
  },
  AU: {
    code: 'AU',
    name: 'Australia',
    alpha3: 'AUS',
    numeric: 36,
    unicodeFlag: '🇦🇺',
    currency: 'AUD',
  },
  AT: {
    code: 'AT',
    name: 'Austria',
    alpha3: 'AUT',
    numeric: 40,
    unicodeFlag: '🇦🇹',
    currency: 'EUR',
  },
  AZ: {
    code: 'AZ',
    name: 'Azerbaijan',
    alpha3: 'AZE',
    numeric: 31,
    unicodeFlag: '🇦🇿',
    currency: 'AZN',
  },
  BS: {
    code: 'BS',
    name: 'Bahamas',
    alpha3: 'BHS',
    numeric: 44,
    unicodeFlag: '🇧🇸',
    currency: 'BSD',
  },
  BH: {
    code: 'BH',
    name: 'Bahrain',
    alpha3: 'BHR',
    numeric: 48,
    unicodeFlag: '🇧🇭',
    currency: 'BHD',
  },
  BD: {
    code: 'BD',
    name: 'Bangladesh',
    alpha3: 'BGD',
    numeric: 50,
    unicodeFlag: '🇧🇩',
    currency: 'BDT',
  },
  BB: {
    code: 'BB',
    name: 'Barbados',
    alpha3: 'BRB',
    numeric: 52,
    unicodeFlag: '🇧🇧',
    currency: 'BBD',
  },
  BY: {
    code: 'BY',
    name: 'Belarus',
    alpha3: 'BLR',
    numeric: 112,
    unicodeFlag: '🇧🇾',
    currency: 'BYN',
  },
  BE: {
    code: 'BE',
    name: 'Belgium',
    alpha3: 'BEL',
    numeric: 56,
    unicodeFlag: '🇧🇪',
    currency: 'EUR',
  },
  BZ: {
    code: 'BZ',
    name: 'Belize',
    alpha3: 'BLZ',
    numeric: 84,
    unicodeFlag: '🇧🇿',
    currency: 'BZD',
  },
  BJ: {
    code: 'BJ',
    name: 'Benin',
    alpha3: 'BEN',
    numeric: 204,
    unicodeFlag: '🇧🇯',
    currency: 'XOF',
  },
  BM: {
    code: 'BM',
    name: 'Bermuda',
    alpha3: 'BMU',
    numeric: 60,
    unicodeFlag: '🇧🇲',
    currency: 'BMD',
  },
  BT: {
    code: 'BT',
    name: 'Bhutan',
    alpha3: 'BTN',
    numeric: 64,
    unicodeFlag: '🇧🇹',
    currency: 'INR',
  },
  BO: {
    code: 'BO',
    name: 'Bolivia',
    alpha3: 'BOL',
    numeric: 68,
    unicodeFlag: '🇧🇴',
    currency: 'BOB',
  },
  BQ: {
    code: 'BQ',
    name: 'Bonaire, Sint Eustatius and Saba',
    alpha3: 'BES',
    numeric: 535,
    unicodeFlag: '🇧🇶',
    currency: 'USD',
  },
  BA: {
    code: 'BA',
    name: 'Bosnia and Herzegovina',
    alpha3: 'BIH',
    numeric: 70,
    unicodeFlag: '🇧🇦',
    currency: 'BAM',
  },
  BW: {
    code: 'BW',
    name: 'Botswana',
    alpha3: 'BWA',
    numeric: 72,
    unicodeFlag: '🇧🇼',
    currency: 'BWP',
  },
  BV: {
    code: 'BV',
    name: 'Bouvet Island',
    alpha3: 'BVT',
    numeric: 74,
    unicodeFlag: '🇧🇻',
    currency: 'NOK',
  },
  BR: {
    code: 'BR',
    name: 'Brazil',
    alpha3: 'BRA',
    numeric: 76,
    unicodeFlag: '🇧🇷',
    currency: 'BRL',
  },
  IO: {
    code: 'IO',
    name: 'British Indian Ocean Territory',
    alpha3: 'IOT',
    numeric: 86,
    unicodeFlag: '🇮🇴',
    currency: 'USD',
  },
  BN: {
    code: 'BN',
    name: 'Brunei',
    alpha3: 'BRN',
    numeric: 96,
    unicodeFlag: '🇧🇳',
    currency: 'BND',
  },
  BG: {
    code: 'BG',
    name: 'Bulgaria',
    alpha3: 'BGR',
    numeric: 100,
    unicodeFlag: '🇧🇬',
    currency: 'BGN',
  },
  BF: {
    code: 'BF',
    name: 'Burkina Faso',
    alpha3: 'BFA',
    numeric: 854,
    unicodeFlag: '🇧🇫',
    currency: 'XOF',
  },
  BI: {
    code: 'BI',
    name: 'Burundi',
    alpha3: 'BDI',
    numeric: 108,
    unicodeFlag: '🇧🇮',
    currency: 'BIF',
  },
  CV: {
    code: 'CV',
    name: 'Cabo Verde',
    alpha3: 'CPV',
    numeric: 132,
    unicodeFlag: '🇨🇻',
    currency: 'CVE',
  },
  KH: {
    code: 'KH',
    name: 'Cambodia',
    alpha3: 'KHM',
    numeric: 116,
    unicodeFlag: '🇰🇭',
    currency: 'KHR',
  },
  CM: {
    code: 'CM',
    name: 'Cameroon',
    alpha3: 'CMR',
    numeric: 120,
    unicodeFlag: '🇨🇲',
    currency: 'XAF',
  },
  CA: {
    code: 'CA',
    name: 'Canada',
    alpha3: 'CAN',
    numeric: 124,
    unicodeFlag: '🇨🇦',
    currency: 'CAD',
  },
  KY: {
    code: 'KY',
    name: 'Cayman Islands',
    alpha3: 'CYM',
    numeric: 136,
    unicodeFlag: '🇰🇾',
    currency: 'KYD',
  },
  CF: {
    code: 'CF',
    name: 'Central African Republic',
    alpha3: 'CAF',
    numeric: 140,
    unicodeFlag: '🇨🇫',
    currency: 'XAF',
  },
  TD: {
    code: 'TD',
    name: 'Chad',
    alpha3: 'TCD',
    numeric: 148,
    unicodeFlag: '🇹🇩',
    currency: 'XAF',
  },
  CL: {
    code: 'CL',
    name: 'Chile',
    alpha3: 'CHL',
    numeric: 152,
    unicodeFlag: '🇨🇱',
    currency: 'CLP',
  },
  CN: {
    code: 'CN',
    name: 'China',
    alpha3: 'CHN',
    numeric: 156,
    unicodeFlag: '🇨🇳',
    currency: 'CNY',
  },
  CX: {
    code: 'CX',
    name: 'Christmas Island',
    alpha3: 'CXR',
    numeric: 162,
    unicodeFlag: '🇨🇽',
    currency: 'AUD',
  },
  CC: {
    code: 'CC',
    name: 'Cocos (Keeling) Islands',
    alpha3: 'CCK',
    numeric: 166,
    unicodeFlag: '🇨🇨',
    currency: 'AUD',
  },
  CO: {
    code: 'CO',
    name: 'Colombia',
    alpha3: 'COL',
    numeric: 170,
    unicodeFlag: '🇨🇴',
    currency: 'COP',
  },
  KM: {
    code: 'KM',
    name: 'Comoros',
    alpha3: 'COM',
    numeric: 174,
    unicodeFlag: '🇰🇲',
    currency: 'KMF',
  },
  CG: {
    code: 'CG',
    name: 'Congo',
    alpha3: 'COG',
    numeric: 178,
    unicodeFlag: '🇨🇬',
    currency: 'XAF',
  },
  CD: {
    code: 'CD',
    name: 'Congo (the Democratic Republic of the)',
    alpha3: 'COD',
    numeric: 180,
    unicodeFlag: '🇨🇩',
    currency: 'CDF',
  },
  CK: {
    code: 'CK',
    name: 'Cook Islands',
    alpha3: 'COK',
    numeric: 184,
    unicodeFlag: '🇨🇰',
    currency: 'NZD',
  },
  CR: {
    code: 'CR',
    name: 'Costa Rica',
    alpha3: 'CRI',
    numeric: 188,
    unicodeFlag: '🇨🇷',
    currency: 'CRC',
  },
  CI: {
    code: 'CI',
    name: "Côte d'Ivoire",
    alpha3: 'CIV',
    numeric: 384,
    unicodeFlag: '🇨🇮',
    currency: 'XOF',
  },
  HR: {
    code: 'HR',
    name: 'Croatia',
    alpha3: 'HRV',
    numeric: 191,
    unicodeFlag: '🇭🇷',
    currency: 'HRK',
  },
  CU: {
    code: 'CU',
    name: 'Cuba',
    alpha3: 'CUB',
    numeric: 192,
    unicodeFlag: '🇨🇺',
    currency: 'CUP',
  },
  CW: {
    code: 'CW',
    name: 'Curaçao',
    alpha3: 'CUW',
    numeric: 531,
    unicodeFlag: '🇨🇼',
    currency: 'ANG',
  },
  CY: {
    code: 'CY',
    name: 'Cyprus',
    alpha3: 'CYP',
    numeric: 196,
    unicodeFlag: '🇨🇾',
    currency: 'EUR',
  },
  CZ: {
    code: 'CZ',
    name: 'Czechia',
    alpha3: 'CZE',
    numeric: 203,
    unicodeFlag: '🇨🇿',
    currency: 'CZK',
  },
  DK: {
    code: 'DK',
    name: 'Denmark',
    alpha3: 'DNK',
    numeric: 208,
    unicodeFlag: '🇩🇰',
    currency: 'DKK',
  },
  DJ: {
    code: 'DJ',
    name: 'Djibouti',
    alpha3: 'DJI',
    numeric: 262,
    unicodeFlag: '🇩🇯',
    currency: 'DJF',
  },
  DM: {
    code: 'DM',
    name: 'Dominica',
    alpha3: 'DMA',
    numeric: 212,
    unicodeFlag: '🇩🇲',
    currency: 'XCD',
  },
  DO: {
    code: 'DO',
    name: 'Dominican Republic',
    alpha3: 'DOM',
    numeric: 214,
    unicodeFlag: '🇩🇴',
    currency: 'DOP',
  },
  EC: {
    code: 'EC',
    name: 'Ecuador',
    alpha3: 'ECU',
    numeric: 218,
    unicodeFlag: '🇪🇨',
    currency: 'USD',
  },
  EG: {
    code: 'EG',
    name: 'Egypt',
    alpha3: 'EGY',
    numeric: 818,
    unicodeFlag: '🇪🇬',
    currency: 'EGP',
  },
  SV: {
    code: 'SV',
    name: 'El Salvador',
    alpha3: 'SLV',
    numeric: 222,
    unicodeFlag: '🇸🇻',
    currency: 'USD',
  },
  GQ: {
    code: 'GQ',
    name: 'Equatorial Guinea',
    alpha3: 'GNQ',
    numeric: 226,
    unicodeFlag: '🇬🇶',
    currency: 'XAF',
  },
  ER: {
    code: 'ER',
    name: 'Eritrea',
    alpha3: 'ERI',
    numeric: 232,
    unicodeFlag: '🇪🇷',
    currency: 'ERN',
  },
  EE: {
    code: 'EE',
    name: 'Estonia',
    alpha3: 'EST',
    numeric: 233,
    unicodeFlag: '🇪🇪',
    currency: 'EUR',
  },
  SZ: {
    code: 'SZ',
    name: 'Eswatini',
    alpha3: 'SWZ',
    numeric: 748,
    unicodeFlag: '🇸🇿',
    currency: 'SZL',
  },
  ET: {
    code: 'ET',
    name: 'Ethiopia',
    alpha3: 'ETH',
    numeric: 231,
    unicodeFlag: '🇪🇹',
    currency: 'ETB',
  },
  FK: {
    code: 'FK',
    name: 'Falkland Islands (Malvinas)',
    alpha3: 'FLK',
    numeric: 238,
    unicodeFlag: '🇫🇰',
    currency: 'FKP',
  },
  FO: {
    code: 'FO',
    name: 'Faroe Islands',
    alpha3: 'FRO',
    numeric: 234,
    unicodeFlag: '🇫🇴',
    currency: 'DKK',
  },
  FJ: {
    code: 'FJ',
    name: 'Fiji',
    alpha3: 'FJI',
    numeric: 242,
    unicodeFlag: '🇫🇯',
    currency: 'FJD',
  },
  FI: {
    code: 'FI',
    name: 'Finland',
    alpha3: 'FIN',
    numeric: 246,
    unicodeFlag: '🇫🇮',
    currency: 'EUR',
  },
  FR: {
    code: 'FR',
    name: 'France',
    alpha3: 'FRA',
    numeric: 250,
    unicodeFlag: '🇫🇷',
    currency: 'EUR',
  },
  GF: {
    code: 'GF',
    name: 'French Guiana',
    alpha3: 'GUF',
    numeric: 254,
    unicodeFlag: '🇬🇫',
    currency: 'EUR',
  },
  PF: {
    code: 'PF',
    name: 'French Polynesia',
    alpha3: 'PYF',
    numeric: 258,
    unicodeFlag: '🇵🇫',
    currency: 'XPF',
  },
  TF: {
    code: 'TF',
    name: 'French Southern Territories',
    alpha3: 'ATF',
    numeric: 260,
    unicodeFlag: '🇹🇫',
    currency: 'EUR',
  },
  GA: {
    code: 'GA',
    name: 'Gabon',
    alpha3: 'GAB',
    numeric: 266,
    unicodeFlag: '🇬🇦',
    currency: 'XAF',
  },
  GM: {
    code: 'GM',
    name: 'Gambia',
    alpha3: 'GMB',
    numeric: 270,
    unicodeFlag: '🇬🇲',
    currency: 'GMD',
  },
  GE: {
    code: 'GE',
    name: 'Georgia',
    alpha3: 'GEO',
    numeric: 268,
    unicodeFlag: '🇬🇪',
    currency: 'GEL',
  },
  DE: {
    code: 'DE',
    name: 'Germany',
    alpha3: 'DEU',
    numeric: 276,
    unicodeFlag: '🇩🇪',
    currency: 'EUR',
  },
  GH: {
    code: 'GH',
    name: 'Ghana',
    alpha3: 'GHA',
    numeric: 288,
    unicodeFlag: '🇬🇭',
    currency: 'GHS',
  },
  GI: {
    code: 'GI',
    name: 'Gibraltar',
    alpha3: 'GIB',
    numeric: 292,
    unicodeFlag: '🇬🇮',
    currency: 'GIP',
  },
  GR: {
    code: 'GR',
    name: 'Greece',
    alpha3: 'GRC',
    numeric: 300,
    unicodeFlag: '🇬🇷',
    currency: 'EUR',
  },
  GL: {
    code: 'GL',
    name: 'Greenland',
    alpha3: 'GRL',
    numeric: 304,
    unicodeFlag: '🇬🇱',
    currency: 'DKK',
  },
  GD: {
    code: 'GD',
    name: 'Grenada',
    alpha3: 'GRD',
    numeric: 308,
    unicodeFlag: '🇬🇩',
    currency: 'XCD',
  },
  GP: {
    code: 'GP',
    name: 'Guadeloupe',
    alpha3: 'GLP',
    numeric: 312,
    unicodeFlag: '🇬🇵',
    currency: 'EUR',
  },
  GU: {
    code: 'GU',
    name: 'Guam',
    alpha3: 'GUM',
    numeric: 316,
    unicodeFlag: '🇬🇺',
    currency: 'USD',
  },
  GT: {
    code: 'GT',
    name: 'Guatemala',
    alpha3: 'GTM',
    numeric: 320,
    unicodeFlag: '🇬🇹',
    currency: 'GTQ',
  },
  GG: {
    code: 'GG',
    name: 'Guernsey',
    alpha3: 'GGY',
    numeric: 831,
    unicodeFlag: '🇬🇬',
    currency: 'GBP',
  },
  GN: {
    code: 'GN',
    name: 'Guinea',
    alpha3: 'GIN',
    numeric: 324,
    unicodeFlag: '🇬🇳',
    currency: 'GNF',
  },
  GW: {
    code: 'GW',
    name: 'Guinea-Bissau',
    alpha3: 'GNB',
    numeric: 624,
    unicodeFlag: '🇬🇼',
    currency: 'XOF',
  },
  GY: {
    code: 'GY',
    name: 'Guyana',
    alpha3: 'GUY',
    numeric: 328,
    unicodeFlag: '🇬🇾',
    currency: 'GYD',
  },
  HT: {
    code: 'HT',
    name: 'Haiti',
    alpha3: 'HTI',
    numeric: 332,
    unicodeFlag: '🇭🇹',
    currency: 'HTG',
  },
  HM: {
    code: 'HM',
    name: 'Heard Island and McDonald Islands',
    alpha3: 'HMD',
    numeric: 334,
    unicodeFlag: '🇭🇲',
    currency: 'AUD',
  },
  VA: {
    code: 'VA',
    name: 'Holy See',
    alpha3: 'VAT',
    numeric: 336,
    unicodeFlag: '🇻🇦',
    currency: 'EUR',
  },
  HN: {
    code: 'HN',
    name: 'Honduras',
    alpha3: 'HND',
    numeric: 340,
    unicodeFlag: '🇭🇳',
    currency: 'HNL',
  },
  HK: {
    code: 'HK',
    name: 'Hong Kong',
    alpha3: 'HKG',
    numeric: 344,
    unicodeFlag: '🇭🇰',
    currency: 'HKD',
  },
  HU: {
    code: 'HU',
    name: 'Hungary',
    alpha3: 'HUN',
    numeric: 348,
    unicodeFlag: '🇭🇺',
    currency: 'HUF',
  },
  IS: {
    code: 'IS',
    name: 'Iceland',
    alpha3: 'ISL',
    numeric: 352,
    unicodeFlag: '🇮🇸',
    currency: 'ISK',
  },
  IN: {
    code: 'IN',
    name: 'India',
    alpha3: 'IND',
    numeric: 356,
    unicodeFlag: '🇮🇳',
    currency: 'INR',
  },
  ID: {
    code: 'ID',
    name: 'Indonesia',
    alpha3: 'IDN',
    numeric: 360,
    unicodeFlag: '🇮🇩',
    currency: 'IDR',
  },
  IR: {
    code: 'IR',
    name: 'Iran',
    alpha3: 'IRN',
    numeric: 364,
    unicodeFlag: '🇮🇷',
    currency: 'IRR',
  },
  IQ: {
    code: 'IQ',
    name: 'Iraq',
    alpha3: 'IRQ',
    numeric: 368,
    unicodeFlag: '🇮🇶',
    currency: 'IQD',
  },
  IE: {
    code: 'IE',
    name: 'Ireland',
    alpha3: 'IRL',
    numeric: 372,
    unicodeFlag: '🇮🇪',
    currency: 'EUR',
  },
  IM: {
    code: 'IM',
    name: 'Isle of Man',
    alpha3: 'IMN',
    numeric: 833,
    unicodeFlag: '🇮🇲',
    currency: 'GBP',
  },
  IL: {
    code: 'IL',
    name: 'Israel',
    alpha3: 'ISR',
    numeric: 376,
    unicodeFlag: '🇮🇱',
    currency: 'ILS',
  },
  IT: {
    code: 'IT',
    name: 'Italy',
    alpha3: 'ITA',
    numeric: 380,
    unicodeFlag: '🇮🇹',
    currency: 'EUR',
  },
  JM: {
    code: 'JM',
    name: 'Jamaica',
    alpha3: 'JAM',
    numeric: 388,
    unicodeFlag: '🇯🇲',
    currency: 'JMD',
  },
  JP: {
    code: 'JP',
    name: 'Japan',
    alpha3: 'JPN',
    numeric: 392,
    unicodeFlag: '🇯🇵',
    currency: 'JPY',
  },
  JE: {
    code: 'JE',
    name: 'Jersey',
    alpha3: 'JEY',
    numeric: 832,
    unicodeFlag: '🇯🇪',
    currency: 'GBP',
  },
  JO: {
    code: 'JO',
    name: 'Jordan',
    alpha3: 'JOR',
    numeric: 400,
    unicodeFlag: '🇯🇴',
    currency: 'JOD',
  },
  KZ: {
    code: 'KZ',
    name: 'Kazakhstan',
    alpha3: 'KAZ',
    numeric: 398,
    unicodeFlag: '🇰🇿',
    currency: 'KZT',
  },
  KE: {
    code: 'KE',
    name: 'Kenya',
    alpha3: 'KEN',
    numeric: 404,
    unicodeFlag: '🇰🇪',
    currency: 'KES',
  },
  KI: {
    code: 'KI',
    name: 'Kiribati',
    alpha3: 'KIR',
    numeric: 296,
    unicodeFlag: '🇰🇮',
    currency: 'AUD',
  },
  XK: {
    code: 'XK',
    name: 'Kosovo',
    alpha3: 'UNK',
    numeric: null,
    unicodeFlag: '🇽🇰',
    currency: 'EUR',
  },
  KW: {
    code: 'KW',
    name: 'Kuwait',
    alpha3: 'KWT',
    numeric: 414,
    unicodeFlag: '🇰🇼',
    currency: 'KWD',
  },
  KG: {
    code: 'KG',
    name: 'Kyrgyzstan',
    alpha3: 'KGZ',
    numeric: 417,
    unicodeFlag: '🇰🇬',
    currency: 'KGS',
  },
  LA: {
    code: 'LA',
    name: 'Laos',
    alpha3: 'LAO',
    numeric: 418,
    unicodeFlag: '🇱🇦',
    currency: 'LAK',
  },
  LV: {
    code: 'LV',
    name: 'Latvia',
    alpha3: 'LVA',
    numeric: 428,
    unicodeFlag: '🇱🇻',
    currency: 'EUR',
  },
  LB: {
    code: 'LB',
    name: 'Lebanon',
    alpha3: 'LBN',
    numeric: 422,
    unicodeFlag: '🇱🇧',
    currency: 'LBP',
  },
  LS: {
    code: 'LS',
    name: 'Lesotho',
    alpha3: 'LSO',
    numeric: 426,
    unicodeFlag: '🇱🇸',
    currency: 'ZAR',
  },
  LR: {
    code: 'LR',
    name: 'Liberia',
    alpha3: 'LBR',
    numeric: 430,
    unicodeFlag: '🇱🇷',
    currency: 'LRD',
  },
  LY: {
    code: 'LY',
    name: 'Libya',
    alpha3: 'LBY',
    numeric: 434,
    unicodeFlag: '🇱🇾',
    currency: 'LYD',
  },
  LI: {
    code: 'LI',
    name: 'Liechtenstein',
    alpha3: 'LIE',
    numeric: 438,
    unicodeFlag: '🇱🇮',
    currency: 'CHF',
  },
  LT: {
    code: 'LT',
    name: 'Lithuania',
    alpha3: 'LTU',
    numeric: 440,
    unicodeFlag: '🇱🇹',
    currency: 'EUR',
  },
  LU: {
    code: 'LU',
    name: 'Luxembourg',
    alpha3: 'LUX',
    numeric: 442,
    unicodeFlag: '🇱🇺',
    currency: 'EUR',
  },
  MO: {
    code: 'MO',
    name: 'Macao',
    alpha3: 'MAC',
    numeric: 446,
    unicodeFlag: '🇲🇴',
    currency: 'MOP',
  },
  MG: {
    code: 'MG',
    name: 'Madagascar',
    alpha3: 'MDG',
    numeric: 450,
    unicodeFlag: '🇲🇬',
    currency: 'MGA',
  },
  MW: {
    code: 'MW',
    name: 'Malawi',
    alpha3: 'MWI',
    numeric: 454,
    unicodeFlag: '🇲🇼',
    currency: 'MWK',
  },
  MY: {
    code: 'MY',
    name: 'Malaysia',
    alpha3: 'MYS',
    numeric: 458,
    unicodeFlag: '🇲🇾',
    currency: 'MYR',
  },
  MV: {
    code: 'MV',
    name: 'Maldives',
    alpha3: 'MDV',
    numeric: 462,
    unicodeFlag: '🇲🇻',
    currency: 'MVR',
  },
  ML: {
    code: 'ML',
    name: 'Mali',
    alpha3: 'MLI',
    numeric: 466,
    unicodeFlag: '🇲🇱',
    currency: 'XOF',
  },
  MT: {
    code: 'MT',
    name: 'Malta',
    alpha3: 'MLT',
    numeric: 470,
    unicodeFlag: '🇲🇹',
    currency: 'EUR',
  },
  MH: {
    code: 'MH',
    name: 'Marshall Islands',
    alpha3: 'MHL',
    numeric: 584,
    unicodeFlag: '🇲🇭',
    currency: 'USD',
  },
  MQ: {
    code: 'MQ',
    name: 'Martinique',
    alpha3: 'MTQ',
    numeric: 474,
    unicodeFlag: '🇲🇶',
    currency: 'EUR',
  },
  MR: {
    code: 'MR',
    name: 'Mauritania',
    alpha3: 'MRT',
    numeric: 478,
    unicodeFlag: '🇲🇷',
    currency: 'MRU',
  },
  MU: {
    code: 'MU',
    name: 'Mauritius',
    alpha3: 'MUS',
    numeric: 480,
    unicodeFlag: '🇲🇺',
    currency: 'MUR',
  },
  YT: {
    code: 'YT',
    name: 'Mayotte',
    alpha3: 'MYT',
    numeric: 175,
    unicodeFlag: '🇾🇹',
    currency: 'EUR',
  },
  MX: {
    code: 'MX',
    name: 'Mexico',
    alpha3: 'MEX',
    numeric: 484,
    unicodeFlag: '🇲🇽',
    currency: 'MXN',
  },
  FM: {
    code: 'FM',
    name: 'Micronesia (Federated States of)',
    alpha3: 'FSM',
    numeric: 583,
    unicodeFlag: '🇫🇲',
    currency: 'USD',
  },
  MD: {
    code: 'MD',
    name: 'Moldova',
    alpha3: 'MDA',
    numeric: 498,
    unicodeFlag: '🇲🇩',
    currency: 'MDL',
  },
  MC: {
    code: 'MC',
    name: 'Monaco',
    alpha3: 'MCO',
    numeric: 492,
    unicodeFlag: '🇲🇨',
    currency: 'EUR',
  },
  MN: {
    code: 'MN',
    name: 'Mongolia',
    alpha3: 'MNG',
    numeric: 496,
    unicodeFlag: '🇲🇳',
    currency: 'MNT',
  },
  ME: {
    code: 'ME',
    name: 'Montenegro',
    alpha3: 'MNE',
    numeric: 499,
    unicodeFlag: '🇲🇪',
    currency: 'EUR',
  },
  MS: {
    code: 'MS',
    name: 'Montserrat',
    alpha3: 'MSR',
    numeric: 500,
    unicodeFlag: '🇲🇸',
    currency: 'XCD',
  },
  MA: {
    code: 'MA',
    name: 'Morocco',
    alpha3: 'MAR',
    numeric: 504,
    unicodeFlag: '🇲🇦',
    currency: 'MAD',
  },
  MZ: {
    code: 'MZ',
    name: 'Mozambique',
    alpha3: 'MOZ',
    numeric: 508,
    unicodeFlag: '🇲🇿',
    currency: 'MZN',
  },
  MM: {
    code: 'MM',
    name: 'Myanmar',
    alpha3: 'MMR',
    numeric: 104,
    unicodeFlag: '🇲🇲',
    currency: 'MMK',
  },
  NA: {
    code: 'NA',
    name: 'Namibia',
    alpha3: 'NAM',
    numeric: 516,
    unicodeFlag: '🇳🇦',
    currency: 'ZAR',
  },
  NR: {
    code: 'NR',
    name: 'Nauru',
    alpha3: 'NRU',
    numeric: 520,
    unicodeFlag: '🇳🇷',
    currency: 'AUD',
  },
  NP: {
    code: 'NP',
    name: 'Nepal',
    alpha3: 'NPL',
    numeric: 524,
    unicodeFlag: '🇳🇵',
    currency: 'NPR',
  },
  NL: {
    code: 'NL',
    name: 'Netherlands',
    alpha3: 'NLD',
    numeric: 528,
    unicodeFlag: '🇳🇱',
    currency: 'EUR',
  },
  NC: {
    code: 'NC',
    name: 'New Caledonia',
    alpha3: 'NCL',
    numeric: 540,
    unicodeFlag: '🇳🇨',
    currency: 'XPF',
  },
  NZ: {
    code: 'NZ',
    name: 'New Zealand',
    alpha3: 'NZL',
    numeric: 554,
    unicodeFlag: '🇳🇿',
    currency: 'NZD',
  },
  NI: {
    code: 'NI',
    name: 'Nicaragua',
    alpha3: 'NIC',
    numeric: 558,
    unicodeFlag: '🇳🇮',
    currency: 'NIO',
  },
  NE: {
    code: 'NE',
    name: 'Niger',
    alpha3: 'NER',
    numeric: 562,
    unicodeFlag: '🇳🇪',
    currency: 'XOF',
  },
  NG: {
    code: 'NG',
    name: 'Nigeria',
    alpha3: 'NGA',
    numeric: 566,
    unicodeFlag: '🇳🇬',
    currency: 'NGN',
  },
  NU: {
    code: 'NU',
    name: 'Niue',
    alpha3: 'NIU',
    numeric: 570,
    unicodeFlag: '🇳🇺',
    currency: 'NZD',
  },
  NF: {
    code: 'NF',
    name: 'Norfolk Island',
    alpha3: 'NFK',
    numeric: 574,
    unicodeFlag: '🇳🇫',
    currency: 'AUD',
  },
  KP: {
    code: 'KP',
    name: 'North Korea',
    alpha3: 'PRK',
    numeric: 408,
    unicodeFlag: '🇰🇵',
    currency: 'KPW',
  },
  MK: {
    code: 'MK',
    name: 'North Macedonia',
    alpha3: 'MKD',
    numeric: 807,
    unicodeFlag: '🇲🇰',
    currency: 'MKD',
  },
  MP: {
    code: 'MP',
    name: 'Northern Mariana Islands',
    alpha3: 'MNP',
    numeric: 580,
    unicodeFlag: '🇲🇵',
    currency: 'USD',
  },
  NO: {
    code: 'NO',
    name: 'Norway',
    alpha3: 'NOR',
    numeric: 578,
    unicodeFlag: '🇳🇴',
    currency: 'NOK',
  },
  OM: {
    code: 'OM',
    name: 'Oman',
    alpha3: 'OMN',
    numeric: 512,
    unicodeFlag: '🇴🇲',
    currency: 'OMR',
  },
  PK: {
    code: 'PK',
    name: 'Pakistan',
    alpha3: 'PAK',
    numeric: 586,
    unicodeFlag: '🇵🇰',
    currency: 'PKR',
  },
  PW: {
    code: 'PW',
    name: 'Palau',
    alpha3: 'PLW',
    numeric: 585,
    unicodeFlag: '🇵🇼',
    currency: 'USD',
  },
  PS: {
    code: 'PS',
    name: 'Palestine, State of',
    alpha3: 'PSE',
    numeric: 275,
    unicodeFlag: '🇵🇸',
    currency: 'ILS',
  },
  PA: {
    code: 'PA',
    name: 'Panama',
    alpha3: 'PAN',
    numeric: 591,
    unicodeFlag: '🇵🇦',
    currency: 'PAB',
  },
  PG: {
    code: 'PG',
    name: 'Papua New Guinea',
    alpha3: 'PNG',
    numeric: 598,
    unicodeFlag: '🇵🇬',
    currency: 'PGK',
  },
  PY: {
    code: 'PY',
    name: 'Paraguay',
    alpha3: 'PRY',
    numeric: 600,
    unicodeFlag: '🇵🇾',
    currency: 'PYG',
  },
  PE: {
    code: 'PE',
    name: 'Peru',
    alpha3: 'PER',
    numeric: 604,
    unicodeFlag: '🇵🇪',
    currency: 'PEN',
  },
  PH: {
    code: 'PH',
    name: 'Philippines',
    alpha3: 'PHL',
    numeric: 608,
    unicodeFlag: '🇵🇭',
    currency: 'PHP',
  },
  PN: {
    code: 'PN',
    name: 'Pitcairn',
    alpha3: 'PCN',
    numeric: 612,
    unicodeFlag: '🇵🇳',
    currency: 'NZD',
  },
  PL: {
    code: 'PL',
    name: 'Poland',
    alpha3: 'POL',
    numeric: 616,
    unicodeFlag: '🇵🇱',
    currency: 'PLN',
  },
  PT: {
    code: 'PT',
    name: 'Portugal',
    alpha3: 'PRT',
    numeric: 620,
    unicodeFlag: '🇵🇹',
    currency: 'EUR',
  },
  PR: {
    code: 'PR',
    name: 'Puerto Rico',
    alpha3: 'PRI',
    numeric: 630,
    unicodeFlag: '🇵🇷',
    currency: 'USD',
  },
  QA: {
    code: 'QA',
    name: 'Qatar',
    alpha3: 'QAT',
    numeric: 634,
    unicodeFlag: '🇶🇦',
    currency: 'QAR',
  },
  RE: {
    code: 'RE',
    name: 'Réunion',
    alpha3: 'REU',
    numeric: 638,
    unicodeFlag: '🇷🇪',
    currency: 'EUR',
  },
  RO: {
    code: 'RO',
    name: 'Romania',
    alpha3: 'ROU',
    numeric: 642,
    unicodeFlag: '🇷🇴',
    currency: 'RON',
  },
  RU: {
    code: 'RU',
    name: 'Russia',
    alpha3: 'RUS',
    numeric: 643,
    unicodeFlag: '🇷🇺',
    currency: 'RUB',
  },
  RW: {
    code: 'RW',
    name: 'Rwanda',
    alpha3: 'RWA',
    numeric: 646,
    unicodeFlag: '🇷🇼',
    currency: 'RWF',
  },
  BL: {
    code: 'BL',
    name: 'Saint Barthélemy',
    alpha3: 'BLM',
    numeric: 652,
    unicodeFlag: '🇧🇱',
    currency: 'EUR',
  },
  SH: {
    code: 'SH',
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    alpha3: 'SHN',
    numeric: 654,
    unicodeFlag: '🇸🇭',
    currency: 'SHP',
  },
  KN: {
    code: 'KN',
    name: 'Saint Kitts and Nevis',
    alpha3: 'KNA',
    numeric: 659,
    unicodeFlag: '🇰🇳',
    currency: 'XCD',
  },
  LC: {
    code: 'LC',
    name: 'Saint Lucia',
    alpha3: 'LCA',
    numeric: 662,
    unicodeFlag: '🇱🇨',
    currency: 'XCD',
  },
  MF: {
    code: 'MF',
    name: 'Saint Martin (French part)',
    alpha3: 'MAF',
    numeric: 663,
    unicodeFlag: '🇲🇫',
    currency: 'EUR',
  },
  PM: {
    code: 'PM',
    name: 'Saint Pierre and Miquelon',
    alpha3: 'SPM',
    numeric: 666,
    unicodeFlag: '🇵🇲',
    currency: 'EUR',
  },
  VC: {
    code: 'VC',
    name: 'Saint Vincent and the Grenadines',
    alpha3: 'VCT',
    numeric: 670,
    unicodeFlag: '🇻🇨',
    currency: 'XCD',
  },
  WS: {
    code: 'WS',
    name: 'Samoa',
    alpha3: 'WSM',
    numeric: 882,
    unicodeFlag: '🇼🇸',
    currency: 'WST',
  },
  SM: {
    code: 'SM',
    name: 'San Marino',
    alpha3: 'SMR',
    numeric: 674,
    unicodeFlag: '🇸🇲',
    currency: 'EUR',
  },
  ST: {
    code: 'ST',
    name: 'Sao Tome and Principe',
    alpha3: 'STP',
    numeric: 678,
    unicodeFlag: '🇸🇹',
    currency: 'STN',
  },
  SA: {
    code: 'SA',
    name: 'Saudi Arabia',
    alpha3: 'SAU',
    numeric: 682,
    unicodeFlag: '🇸🇦',
    currency: 'SAR',
  },
  SN: {
    code: 'SN',
    name: 'Senegal',
    alpha3: 'SEN',
    numeric: 686,
    unicodeFlag: '🇸🇳',
    currency: 'XOF',
  },
  RS: {
    code: 'RS',
    name: 'Serbia',
    alpha3: 'SRB',
    numeric: 688,
    unicodeFlag: '🇷🇸',
    currency: 'RSD',
  },
  SC: {
    code: 'SC',
    name: 'Seychelles',
    alpha3: 'SYC',
    numeric: 690,
    unicodeFlag: '🇸🇨',
    currency: 'SCR',
  },
  SL: {
    code: 'SL',
    name: 'Sierra Leone',
    alpha3: 'SLE',
    numeric: 694,
    unicodeFlag: '🇸🇱',
    currency: 'SLL',
  },
  SG: {
    code: 'SG',
    name: 'Singapore',
    alpha3: 'SGP',
    numeric: 702,
    unicodeFlag: '🇸🇬',
    currency: 'SGD',
  },
  SX: {
    code: 'SX',
    name: 'Sint Maarten (Dutch part)',
    alpha3: 'SXM',
    numeric: 534,
    unicodeFlag: '🇸🇽',
    currency: 'ANG',
  },
  SK: {
    code: 'SK',
    name: 'Slovakia',
    alpha3: 'SVK',
    numeric: 703,
    unicodeFlag: '🇸🇰',
    currency: 'EUR',
  },
  SI: {
    code: 'SI',
    name: 'Slovenia',
    alpha3: 'SVN',
    numeric: 705,
    unicodeFlag: '🇸🇮',
    currency: 'EUR',
  },
  SB: {
    code: 'SB',
    name: 'Solomon Islands',
    alpha3: 'SLB',
    numeric: 90,
    unicodeFlag: '🇸🇧',
    currency: 'SBD',
  },
  SO: {
    code: 'SO',
    name: 'Somalia',
    alpha3: 'SOM',
    numeric: 706,
    unicodeFlag: '🇸🇴',
    currency: 'SOS',
  },
  ZA: {
    code: 'ZA',
    name: 'South Africa',
    alpha3: 'ZAF',
    numeric: 710,
    unicodeFlag: '🇿🇦',
    currency: 'ZAR',
  },
  GS: {
    code: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
    alpha3: 'SGS',
    numeric: 239,
    unicodeFlag: '🇬🇸',
    currency: 'GBP',
  },
  KR: {
    code: 'KR',
    name: 'South Korea',
    alpha3: 'KOR',
    numeric: 410,
    unicodeFlag: '🇰🇷',
    currency: 'KRW',
  },
  SS: {
    code: 'SS',
    name: 'South Sudan',
    alpha3: 'SSD',
    numeric: 728,
    unicodeFlag: '🇸🇸',
    currency: 'SSP',
  },
  ES: {
    code: 'ES',
    name: 'Spain',
    alpha3: 'ESP',
    numeric: 724,
    unicodeFlag: '🇪🇸',
    currency: 'EUR',
  },
  LK: {
    code: 'LK',
    name: 'Sri Lanka',
    alpha3: 'LKA',
    numeric: 144,
    unicodeFlag: '🇱🇰',
    currency: 'LKR',
  },
  SD: {
    code: 'SD',
    name: 'Sudan',
    alpha3: 'SDN',
    numeric: 729,
    unicodeFlag: '🇸🇩',
    currency: 'SDG',
  },
  SR: {
    code: 'SR',
    name: 'Suriname',
    alpha3: 'SUR',
    numeric: 740,
    unicodeFlag: '🇸🇷',
    currency: 'SRD',
  },
  SJ: {
    code: 'SJ',
    name: 'Svalbard and Jan Mayen',
    alpha3: 'SJM',
    numeric: 744,
    unicodeFlag: '🇸🇯',
    currency: 'NOK',
  },
  SE: {
    code: 'SE',
    name: 'Sweden',
    alpha3: 'SWE',
    numeric: 752,
    unicodeFlag: '🇸🇪',
    currency: 'SEK',
  },
  CH: {
    code: 'CH',
    name: 'Switzerland',
    alpha3: 'CHE',
    numeric: 756,
    unicodeFlag: '🇨🇭',
    currency: 'CHF',
  },
  SY: {
    code: 'SY',
    name: 'Syria',
    alpha3: 'SYR',
    numeric: 760,
    unicodeFlag: '🇸🇾',
    currency: 'SYP',
  },
  TW: {
    code: 'TW',
    name: 'Taiwan',
    alpha3: 'TWN',
    numeric: 158,
    unicodeFlag: '🇹🇼',
    currency: 'TWD',
  },
  TJ: {
    code: 'TJ',
    name: 'Tajikistan',
    alpha3: 'TJK',
    numeric: 762,
    unicodeFlag: '🇹🇯',
    currency: 'TJS',
  },
  TZ: {
    code: 'TZ',
    name: 'Tanzania',
    alpha3: 'TZA',
    numeric: 834,
    unicodeFlag: '🇹🇿',
    currency: 'TZS',
  },
  TH: {
    code: 'TH',
    name: 'Thailand',
    alpha3: 'THA',
    numeric: 764,
    unicodeFlag: '🇹🇭',
    currency: 'THB',
  },
  TL: {
    code: 'TL',
    name: 'Timor-Leste',
    alpha3: 'TLS',
    numeric: 626,
    unicodeFlag: '🇹🇱',
    currency: 'USD',
  },
  TG: {
    code: 'TG',
    name: 'Togo',
    alpha3: 'TGO',
    numeric: 768,
    unicodeFlag: '🇹🇬',
    currency: 'XOF',
  },
  TK: {
    code: 'TK',
    name: 'Tokelau',
    alpha3: 'TKL',
    numeric: 772,
    unicodeFlag: '🇹🇰',
    currency: 'NZD',
  },
  TO: {
    code: 'TO',
    name: 'Tonga',
    alpha3: 'TON',
    numeric: 776,
    unicodeFlag: '🇹🇴',
    currency: 'TOP',
  },
  TT: {
    code: 'TT',
    name: 'Trinidad and Tobago',
    alpha3: 'TTO',
    numeric: 780,
    unicodeFlag: '🇹🇹',
    currency: 'TTD',
  },
  TN: {
    code: 'TN',
    name: 'Tunisia',
    alpha3: 'TUN',
    numeric: 788,
    unicodeFlag: '🇹🇳',
    currency: 'TND',
  },
  TR: {
    code: 'TR',
    name: 'Turkey',
    alpha3: 'TUR',
    numeric: 792,
    unicodeFlag: '🇹🇷',
    currency: 'TRY',
  },
  TM: {
    code: 'TM',
    name: 'Turkmenistan',
    alpha3: 'TKM',
    numeric: 795,
    unicodeFlag: '🇹🇲',
    currency: 'TMT',
  },
  TC: {
    code: 'TC',
    name: 'Turks and Caicos Islands',
    alpha3: 'TCA',
    numeric: 796,
    unicodeFlag: '🇹🇨',
    currency: 'USD',
  },
  TV: {
    code: 'TV',
    name: 'Tuvalu',
    alpha3: 'TUV',
    numeric: 798,
    unicodeFlag: '🇹🇻',
    currency: 'AUD',
  },
  UG: {
    code: 'UG',
    name: 'Uganda',
    alpha3: 'UGA',
    numeric: 800,
    unicodeFlag: '🇺🇬',
    currency: 'UGX',
  },
  UA: {
    code: 'UA',
    name: 'Ukraine',
    alpha3: 'UKR',
    numeric: 804,
    unicodeFlag: '🇺🇦',
    currency: 'UAH',
  },
  AE: {
    code: 'AE',
    name: 'United Arab Emirates',
    alpha3: 'ARE',
    numeric: 784,
    unicodeFlag: '🇦🇪',
    currency: 'AED',
  },
  GB: {
    code: 'GB',
    name: 'United Kingdom',
    alpha3: 'GBR',
    numeric: 826,
    unicodeFlag: '🇬🇧',
    currency: 'GBP',
  },
  UM: {
    code: 'UM',
    name: 'United States Minor Outlying Islands',
    alpha3: 'UMI',
    numeric: 581,
    unicodeFlag: '🇺🇲',
    currency: 'USD',
  },
  US: {
    code: 'US',
    name: 'United States of America',
    alpha3: 'USA',
    numeric: 840,
    unicodeFlag: '🇺🇸',
    currency: 'USD',
  },
  UY: {
    code: 'UY',
    name: 'Uruguay',
    alpha3: 'URY',
    numeric: 858,
    unicodeFlag: '🇺🇾',
    currency: 'UYU',
  },
  UZ: {
    code: 'UZ',
    name: 'Uzbekistan',
    alpha3: 'UZB',
    numeric: 860,
    unicodeFlag: '🇺🇿',
    currency: 'UZS',
  },
  VU: {
    code: 'VU',
    name: 'Vanuatu',
    alpha3: 'VUT',
    numeric: 548,
    unicodeFlag: '🇻🇺',
    currency: 'VUV',
  },
  VE: {
    code: 'VE',
    name: 'Venezuela',
    alpha3: 'VEN',
    numeric: 862,
    unicodeFlag: '🇻🇪',
    currency: 'VES',
  },
  VN: {
    code: 'VN',
    name: 'Vietnam',
    alpha3: 'VNM',
    numeric: 704,
    unicodeFlag: '🇻🇳',
    currency: 'VND',
  },
  VG: {
    code: 'VG',
    name: 'Virgin Islands (British)',
    alpha3: 'VGB',
    numeric: 92,
    unicodeFlag: '🇻🇬',
    currency: 'USD',
  },
  VI: {
    code: 'VI',
    name: 'Virgin Islands (U.S.)',
    alpha3: 'VIR',
    numeric: 850,
    unicodeFlag: '🇻🇮',
    currency: 'USD',
  },
  WF: {
    code: 'WF',
    name: 'Wallis and Futuna',
    alpha3: 'WLF',
    numeric: 876,
    unicodeFlag: '🇼🇫',
    currency: 'XPF',
  },
  EH: {
    code: 'EH',
    name: 'Western Sahara',
    alpha3: 'ESH',
    numeric: 732,
    unicodeFlag: '🇪🇭',
    currency: 'MAD',
  },
  YE: {
    code: 'YE',
    name: 'Yemen',
    alpha3: 'YEM',
    numeric: 887,
    unicodeFlag: '🇾🇪',
    currency: 'YER',
  },
  ZM: {
    code: 'ZM',
    name: 'Zambia',
    alpha3: 'ZMB',
    numeric: 894,
    unicodeFlag: '🇿🇲',
    currency: 'ZMW',
  },
  ZW: {
    code: 'ZW',
    name: 'Zimbabwe',
    alpha3: 'ZWE',
    numeric: 716,
    unicodeFlag: '🇿🇼',
    currency: 'USD',
  },
};
